
// window.upcartOnCartUpdated = updateRewardCircles;
window.upcartOnAddToCart = updateRewardCircles;
window.upcartOnItemRemoved = updateRewardCircles;
window.upcartOnCartLoaded = updateCartLoaded;
window.upcartModifyCart = updateCartRewards;

function hexToRgb(hex) {
    hex = hex.replace(/^#/, '');

    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return `rgb(${r}, ${g}, ${b})`;
}

function updateCartLoaded() {
  replaceWithParagraph("#UpcartPopup h3");
  replaceWithParagraph("#UpcartPopup h2");
  updateRewardCircles();
}

function replaceWithParagraph(elem) {
  var h3 = $(elem);
  var paragraph = $("<p>").html(h3.html());
  $.each(h3[0].attributes, function() {
    if (this.specified) {
      paragraph.attr(this.name, this.value);
    }
  })

  h3.replaceWith(paragraph);

}

function updateRewardCircles() {
    var rewardSettingsBg = window.upcartSettings.upcartEditorSettings.rewardsBarForegroundColor;
    setTimeout(() => {
      $(".upcart-rewards-tier-circle").each(function(index, element){
        var rewardCircle = $(element);
    
        if (rewardCircle.css("fill") === 'rgb(216, 214, 212)') {
          // complete
          rewardCircle.css("background-color", "#EFEFEF");
          rewardCircle.css("fill", "rgb(44, 71, 142)");
          rewardCircle.css("border", `2px solid rgb(44, 71, 142)`);
        } else if (rewardCircle.css("fill") === 'rgb(44, 71, 141)') {
          // not complete
          rewardCircle.css("background-color", "#EFEFEF");
          rewardCircle.css("border", "2px solid #D8D6D4");
          rewardCircle.css("fill", "#999999");
        }
      });
    }, 25);
}

function updateCartRewards(cart) {
  var rewardsTotal = 0; 
  var rewardTiers = window.upcartSettings.upcartEditorSettings.rewardsTiers.tiers;

  for (const tier of rewardTiers) {
    rewardsTotal += +tier.minAmount;
  }

  var totalPrice = cart.total_price / 100;
  var totalPercent = (totalPrice / rewardsTotal) * 100;

  if (totalPercent > 100) {
    totalPercent = 100;
  }
  
  setTimeout(() => {
    $(".upcart-rewards-bar-foreground").css("width", `${totalPercent}%`);
  }, 25);
}

$(document).on('click', function(event) {
  // Find the closest element with the class 'mobile-facets__collapsible--heading-holder'
    var header = $(event.target).closest('.mobile-facets__collapsible--heading-holder');
    
    if (header.length) {
      toggleFacetHeader(header);
    }
});

function toggleFacetHeader(header) {
  console.log("has class");
  header.toggleClass("mobile-facets__collapsible--active");

  var nextSibling = header.next()[0];

  if (nextSibling.style.maxHeight) {
      nextSibling.style.maxHeight = null;
  } else {
      nextSibling.style.maxHeight = nextSibling.scrollHeight + "px";
  }
}

function showActiveFacets() {
  $(".mobile-facets__collapsible--details").each(function() {
    var header = $(this);
    var headerToggable = header.find(".mobile-facets__collapsible--heading-holder")
    var checkbox = header.find('input[type="checkbox"]:checked');

    if (checkbox.length) {
      toggleFacetHeader(headerToggable);
    }
  })

}

showActiveFacets();

// $(".mobile-facets__collapsible--heading-holder")

//   // Collapsible Filter
//   var collapsibleHeading = document.getElementsByClassName("mobile-facets__collapsible--heading-holder");
//   var i;

//   for (i = 0; i < collapsibleHeading.length; i++) {
//     collapsibleHeading[i].addEventListener("click", function() {
//       console.log("head", collapsibleHeading[i], this.nextElementSibling);
//       this.classList.toggle("mobile-facets__collapsible--active");
//       var collapsibleContent = this.nextElementSibling;
//       if (collapsibleContent.style.maxHeight){
//         collapsibleContent.style.maxHeight = null;
//       } else {
//         collapsibleContent.style.maxHeight = collapsibleContent.scrollHeight + "px";
//       } 
//     });
//   }

window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type == 'embedOpen') {
    setTimeout(() => {
      var klaviyoImage = $(".klaviyo-form img");
      console.log("klaviyo image", klaviyoImage);
      console.log("klaviyo image", $(".klaviyo-form img"));
      if (klaviyoImage.length > 0) {
        klaviyoImage.attr("width", "100px");
        klaviyoImage.attr("height", "100px");
      }
    }, 600);
  }
});